import { CartesianGrid, ComposedChart, Line, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { T } from "./theme";
import { buildChartData, formatShortDate, monthTicks, toIso } from "./licenseGoalMath";

const formatTick = (ms) => formatShortDate(toIso(ms));

export default function LicenseGoalChart({ goal, points }) {
  const data = buildChartData({
    startDate: goal.start_date,
    endDate: goal.end_date,
    startCount: goal.start_count,
    goalCount: goal.goal_count,
    points,
  });
  const lastActual = [...data].reverse().find((row) => row.actual != null);
  const yMin = Math.floor(goal.start_count / 1000) * 1000;
  const yMax = Math.ceil(goal.goal_count / 1000) * 1000;

  const renderActualDot = ({ cx, cy, payload, index }) => {
    if (payload.actual == null || cx == null || cy == null) return <g key={index} />;
    const isLast = lastActual && payload.time === lastActual.time;
    return (
      <g key={index}>
        <circle cx={cx} cy={cy} r={isLast ? 5 : 3} fill={T.accent} />
        {isLast && (
          <text x={cx + 10} y={cy + 14} fill={T.text} fontSize={11} fontWeight={600}>
            {payload.actual.toLocaleString()}
          </text>
        )}
      </g>
    );
  };

  return (
    <div style={{ width: "100%", height: 300 }}>
      <ResponsiveContainer>
        <ComposedChart data={data} margin={{ top: 16, right: 72, bottom: 4, left: 8 }}>
          <CartesianGrid stroke={T.border} vertical={false} />
          <XAxis
            dataKey="time"
            type="number"
            scale="time"
            domain={[data[0].time, data[data.length - 1].time]}
            ticks={monthTicks(goal.start_date, goal.end_date)}
            tickFormatter={formatTick}
            stroke={T.textDim}
            tick={{ fontSize: 11, fill: T.textDim }}
            tickLine={false}
          />
          <YAxis
            domain={[yMin, yMax]}
            tickFormatter={(v) => v.toLocaleString()}
            stroke={T.textDim}
            tick={{ fontSize: 11, fill: T.textDim }}
            tickLine={false}
            axisLine={false}
            width={52}
          />
          <Tooltip
            labelFormatter={formatTick}
            formatter={(value, name) => [value.toLocaleString(), name === "actual" ? "Actual" : "Pace"]}
            contentStyle={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: T.radiusSm, fontSize: 12, color: T.text }}
          />
          <ReferenceLine
            y={goal.goal_count}
            stroke={T.textMuted}
            label={{ value: `Goal ${goal.goal_count.toLocaleString()}`, position: "right", fill: T.text, fontSize: 11, fontWeight: 600 }}
          />
          <Line type="linear" dataKey="pace" stroke={T.textDim} strokeDasharray="5 5" strokeWidth={1.5} dot={false} activeDot={false} isAnimationActive={false} />
          <Line type="linear" dataKey="actual" stroke={T.accent} strokeWidth={2} connectNulls dot={renderActualDot} activeDot={false} isAnimationActive={false} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
